import { createClient } from "@supabase/supabase-js";

const url = process.env.REACT_APP_SUPABASE_URL;
const key = process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY;

if (!url || !key) {
  // Aide au diagnostic si les variables d'environnement manquent
  // eslint-disable-next-line no-console
  console.warn("[Supabase] Variables d'environnement manquantes (REACT_APP_SUPABASE_URL / REACT_APP_SUPABASE_PUBLISHABLE_KEY).");
}

export const supabase = createClient(url || "http://localhost", key || "public-anon-key", {
  auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true },
});
